import styled from "styled-components";

const CONTAINER_WIDTH = 770;
const MAX_WIDTH = CONTAINER_WIDTH + 24 * 2 + 20 * 2;
const MEDIA_MOBILE = `(max-width: ${MAX_WIDTH}px)`;
const MEDIA_NON_MOBILE = `(min-width: ${MAX_WIDTH + 1}px)`;

export const CardContainer = styled.div`
  width: ${CONTAINER_WIDTH}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  background-color: transparent;

  @media ${MEDIA_MOBILE} {
    width: 100%;
    align-self: stretch;
  }
`;

export const TopSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 12px;

  @media ${MEDIA_MOBILE} {
    align-self: stretch;
  }
`;

export const AnswerIcon = styled.div`
  min-width: 91px;
  width: 91px;
  height: 63px;
  position: relative;

  &::before {
    content: "";
    z-index: -1;
    position: absolute;
    top: -8px;
    left: 2px;
    width: 90px;
    height: 75px;
    background-image: url("/images/character-emotions/neutral.svg");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  @media ${MEDIA_MOBILE} {
    min-width: 84px;
    width: 84px;
    height: 59px;

    &::before {
      top: -9px;
      left: 0;
      width: 83px;
      height: 69px;
    }
  }
`;

export const AnswerInput = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 24px;
  padding: 16px 24px;
  background-color: rgba(255, 255, 255, 0.6);
  border-radius: 20px 20px 20px 4px;

  @media ${MEDIA_MOBILE} {
    padding: 8px 16px;
    border-radius: 16px 16px 16px 4px;
    align-self: stretch;
    flex-direction: column;
    flex-grow: 1;
  }
`;

export const TextInputFrame = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;

  @media ${MEDIA_MOBILE} {
    justify-content: stretch;
    align-items: stretch;
    align-self: stretch;
    width: 100%; /* horizontal: fill */
  }
`;

export const QuestionText = styled.p`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 500;
  font-size: 20px;
  line-height: 1.5em;
  color: rgba(29, 29, 29, 0.85);
  text-align: left;

  br {
    @media ${MEDIA_NON_MOBILE} {
      display: none;
    }
  }

  @media ${MEDIA_MOBILE} {
    font-size: 16px;
  }
`;

export const StyledButton = styled.a`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 8px 20px;
  background-color: #1d1d1d;
  border-radius: 12px;
  height: 48px;
  color: #ffffff;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 600;
  font-size: 16px;
  line-height: 1.5em;
  cursor: pointer;
  flex-wrap: nowrap;
  white-space: nowrap;
  text-decoration: none;
  box-shadow: none;
  outline: none;
  border: none;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;

  &:hover {
    // background-color: rgba(29, 29, 29, 0.85);
    opacity: 0.85;
  }

  @media ${MEDIA_MOBILE} {
    align-self: stretch;
    width: 100%;
  }

  &::before {
    content: "";
    position: absolute;
    top: 38.26px;
    left: 8.81%;
    right: 8.81%;
    width: calc(100% - 8.81% * 2);
    height: 55.57px;
    background-color: #fc714a;
    filter: blur(16px);
    opacity: 0.3;
    border-radius: 59.055px;
    z-index: 0;
  }

  span {
    position: relative;
    z-index: 1;
  }
`;

export const ButtonText = styled.span`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 600;
  font-size: 16px;
  line-height: 1.5em;
  color: #ffffff;
`;

export const ButtonIcon = styled.img.attrs({
  src: "/images/icons/arrow-top-right-white-2.svg",
  alt: "Arrow right",
})`
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
`;
